<template>
    <v-card>
        <v-card-title>Telegram Integration</v-card-title>

        <v-divider />

        <v-card-text>
            <v-stepper v-model="step" vertical flat style="background-color: #424242;" class="elevation-0 mt-3">
                <v-stepper-step step="1" :complete="step > 1" color="#c42111">
                    <v-stepper-content step="1">
                        Within the Telegram App, search for user Telsasoft. You should see "@telsasoft_bot". Add Telsasoft.
                        <v-btn height="30" class="d-block mt-2" color="#c42111" @click="stepOneComplete">Ok</v-btn>
                    </v-stepper-content>
                </v-stepper-step>
                <v-stepper-step step="2" :complete="step > 2" color="#c42111">
                    <v-stepper-content step="2">
                        <div v-if="gettingCode">
                            <v-icon class="loader">fas fa-spinner fa-spin</v-icon>
                        </div>
                        <div v-if="!gettingCode">
                            Send this code as a message to Telsasoft. <span style="font-weight: bold;">{{telegramCode}}</span>
                            <v-btn height="30" class="d-block mt-2" color="#c42111" @click="stepTwoComplete">Ok</v-btn>
                        </div>
                    </v-stepper-content>
                </v-stepper-step>

                <v-stepper-step step="3" :complete="step > 3" color="#c42111">
                    <v-stepper-content step="3">
                        <div v-if="verifying">
                            Verifying code. Please wait... <v-icon class="wait-spin">fas fa-spinner fa-spin</v-icon>
                        </div>
                        <div class="failed" v-else-if="failed">
                            <span>Telegram Integration Failed. <v-icon color="#ff5252">mdi-alert</v-icon></span>
                        </div>
                        <div class="succeeded" v-else-if="succeeded">
                            <span>Telegram Integration Success! <v-icon color="#4caf50">mdi-check-circle</v-icon></span>
                        </div>
                    </v-stepper-content>
                </v-stepper-step>

            </v-stepper>
        </v-card-text>

        <v-divider />

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="$emit('cancel')">Cancel</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: 'VerifyTelegram',
    props: ['editUser'],
    components: {
    },
    data: () => ({
        step: 1,
        gettingCode: false,
        telegramCode: null,
        resending: false,
        verifying: false,
        failed: false,
        succeeded: false,
        clockTickIntervalFunc: null,
        expTimerSec: 600,
        webappAuthKey: null
    }),

    computed: {
        
    },

    methods: {
        stepOneComplete: function() {
            this.getWebappAuthKey().then(r => {
                this.startIntegration(false);
            })
        },

        startIntegration: function(resend) {
            this.gettingCode = true;
            this.step = 2;
            this.expTimerSec = 600;
            this.resending = resend;
            let route = 'https://page.telsasoft.com/api/v1/telegramverification/start';
            return this.$http.post(route, {webapp_auth_key: this.webappAuthKey, username: this.$store.state.user.user_username, customer: this.$store.state.batchConfig.licensee}).then(response => {
                this.resending = false;
                this.gettingCode = false;
                let result = response.body;
                this.telegramCode = result;
            });
        },

        stepTwoComplete: function() {
            this.verifyTelegram();
        },

        verifyTelegram: function() {
            this.step = 3;
            this.verifying = true;
            let route = 'https://page.telsasoft.com/api/v1/telegramverification/verify';
            return this.$http.post(route, {webapp_auth_key: this.webappAuthKey, username: this.$store.state.user.user_username, customer: this.$store.state.batchConfig.licensee}).then(response => {
                let result = response.body;
                console.log('RESULT: ', result);
                if(result.id) {
                    let sRoute = (TELSA.apiHost + "verifytelegram/success");
                    return this.$http.post(sRoute, {args: {user_id: this.$props.editUser.user_id, telegram_user_id: result.id, telegram_user_data: result}}).then(response => {
                        this.verifying = false;
                        this.succeeded = true;
                        let self = this;
                        setTimeout(function() {
                            self.$emit('success', result.id);
                        }, 1000);
                    });
                }
                else {
                    this.verifying = false;
                    this.failed = true;
                }
            });
        },

        getWebappAuthKey: function() {
            let route = (TELSA.apiHost + "auth/keys");
            let args = {requested_keys: ['webapp_auth_key']}
            return this.$http.post(route, {args: args}).then(response => {
                let result = response.body;
                this.webappAuthKey = result.webapp_auth_key;
            });
        }


        

        

        // setupTimer: function() {
        //     let self = this;
        //     clearInterval(this.clockTickIntervalFunc);
        //     this.clockTickIntervalFunc = setInterval(function() {
        //         if(self.expTimerSec > 0) {
        //             self.expTimerSec = (self.expTimerSec - 1);
        //         }
        //         else {
        //             self.$emit('cancel');
        //         }
        //     }, 1000);
        // }

    },

    mounted() {
        //this.startVerification(false);
        //this.setupTimer();
    },

    destroyed() {
        //clearInterval(this.clockTickIntervalFunc);
    },
  
};
</script>

<style scoped>

    .failed span {
        color: #ff5252;
        font-size: 14px;
    }

    .succeeded span {
        color: #4caf50;
        font-size: 14px;
    }

</style>



